// src/data/pharmacistMockData.js

export const inventoryMockData = [
  {
    id: 1,
    name: 'Sertraline',
    category: 'Mental Health',
    stock: 5,
    stockStatus: 'Low Stock',
    expiry: '2024-05-12',
    reordering: false,
    details: '50mg tablet, taken daily',
    reorderHistory: 'Last reordered on 2023-08-15',
  },
  {
    id: 2,
    name: 'Lorazepam',
    category: 'Mental Health',
    stock: 0,
    stockStatus: 'Out of Stock',
    expiry: '2023-10-01',
    reordering: false,
    details: '1mg tablet, taken as needed',
    reorderHistory: 'Last reordered on 2023-06-10',
  },
  {
    id: 3,
    name: 'Fluoxetine',
    category: 'Mental Health',
    stock: 12,
    stockStatus: 'In Stock',
    expiry: '2025-02-15',
    reordering: false,
    details: '20mg tablet, taken daily',
    reorderHistory: 'No reorder history available',
  },
  {
    id: 4,
    name: 'Ibuprofen',
    category: 'Pain Relievers',
    stock: 25,
    stockStatus: 'In Stock',
    expiry: '2023-12-30',
    reordering: false,
    details: '200mg tablet, taken as needed',
    reorderHistory: 'Last reordered on 2023-09-05',
  },
];
